<template>
	<c-dialog ref="dialog" title="选择角色" width="900" @resolve="resolve">
		<c-table ref="table" height="400" :paging="false">
			<c-table-column
				type="selector"
				:multiple="!!multiple"
                :selected="row => row.data.checked"
			></c-table-column>
			
			<c-table-column
				label="角色名称"
				width="200"
				name="role_name"
			></c-table-column>
			
			<c-table-column
				label="角色描述"
				width="500"
				name="remarks"
			></c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
		props: {
			multiple: Boolean
		},
		
		methods: {
			open(id) {
				this.$refs.dialog.open();
				this.$refs.table.load({
					url: '/stationed/role/list/all',
					data: {
						user_id:id
					}
				});
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						message: '请选择角色'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>